import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVenmo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 33,
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: .212891,
		width: 32,
		height: 32,
		rx: 16,
		fill: "#008CFF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.1033 8.52539C23.7256 9.54939 24.0061 10.604 24.0061 11.9362C24.0061 16.1855 20.3659 21.7055 17.4113 25.5817H10.6632L7.95703 9.45588L13.8657 8.89695L15.2964 20.3714C16.6333 18.2011 18.2834 14.7903 18.2834 12.4646C18.2834 11.1917 18.0644 10.3249 17.7227 9.6109L23.1033 8.52539Z",
		fill: "white"
	})]
});
export default SvgVenmo;
